<script setup>
import { GaMobileOnlyStub } from '~/modules/app'

const { $gaApp } = useNuxtApp()

const hasAccess = $gaApp.services.app.mobileOnlyStub.hasAccess
</script>

<template>
  <Html>
    <Body>
      <NuxtLoadingIndicator color="#ddff0e" :height="3" />

      <ga-mobile-only-stub v-if="!hasAccess" />

      <NuxtLayout v-else>
        <NuxtPage />
      </NuxtLayout>
    </Body>
  </Html>
</template>
